import { type FC } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { FormHelperText } from 'base-ui'

import { type DirectContactFormValues } from '../DirectContactFormModel'

import { DirectContactFormOrderProductsSelectionContainer } from './DirectContactFormOrderProductsSelectionContainer'

const getSelectedProductNames = (
  selectedProducts: DirectContactFormValues['selectedProducts'],
): string => selectedProducts.map(({ itemName }) => itemName).join(', ')

export const DirectContactFormProductSelectionField: FC<{
  onClick: () => void
}> = ({ onClick }) => {
  const intl = useIntl()
  const { control } = useFormContext<DirectContactFormValues>()
  const selectedProducts = useWatch({ control, name: 'selectedProducts' })
  const selectedProductNames = getSelectedProductNames(selectedProducts)
  const requiredMessage = intl.formatMessage({ id: 'form.error.input.missing' })

  return (
    <Controller
      control={control}
      name="productCode"
      render={({ fieldState }) => (
        <div className="min-w-0">
          <DirectContactFormOrderProductsSelectionContainer
            data-qa-id="contact-form-productCode"
            hasError={Boolean(fieldState.error)}
            label={`${intl.formatMessage({
              id: 'direct.contact.form.select.product.title',
            })}*`}
            onClick={onClick}
            selectedValue={selectedProductNames}
          />
          {fieldState.error?.message ? (
            <FormHelperText
              className="px-6 text-dark-error"
              data-qa-id="contact-form-productCode-error"
              id="contact-form-productCode-error"
            >
              {fieldState.error.message}
            </FormHelperText>
          ) : null}
        </div>
      )}
      rules={{ required: requiredMessage }}
    />
  )
}
